import { Box, Button, Modal, Typography } from "@mui/material"
import { MuiOtpInput } from "mui-one-time-password-input"
import { filterNonDigits } from "../../libs/utils"
import { useEffect, useState } from "react"
import { useContext } from "react"
import { AuthContext } from "../../libs/contexts/authContext"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorIcon from '@mui/icons-material/Error'

const EmailVerifyModal = ({ show, setShow, email, handleResend, isVerifyError, verifyEmail }) => {
  const [otp, setOtp] = useState('')
  const [resendDisabled, setResendDisabled] = useState(false)
  const [countdown, setCountdown] = useState(60)

  const { affiliateCode, productId } = useContext(AuthContext)

  useEffect(() => {
    return () => {
      setOtp('')
    }
  }, [])

  useEffect(() => {
    if (resendDisabled) {
      startResendTimer()
    }
    return () => {
      setResendDisabled(false)
      setCountdown(60)
    }
  }, [resendDisabled])

  const startResendTimer = () => {
    setResendDisabled(true)
    let timeLeft = 60
    const timer = setInterval(() => {
      timeLeft--
      setCountdown(timeLeft)
      if (timeLeft === 0) {
        setResendDisabled(false)
        clearInterval(timer)
      }
    }, 1000)
  }

  const handleOtpChange = (val) => {
    const filteredVal = filterNonDigits(val)
    setOtp(filteredVal)
  }

  const resend = async () => {
    // const inputPayload = {
    //   affiliateCode,
    //   email: workEmail,
    // }
    // await axios.post(`${apiURL}`, {
    //   ...inputPayload,
    //   prsCode: '3702F702',
    // })
    handleResend()
    setResendDisabled(true)
    setCountdown(60)
  }

  const matchVerificationCode = () => {
    // const inputPayload = {
    //   affiliateCode,
    //   email: workEmail,
    //   verification_code: Number(otp),
    // }
    // dispatch(verifyEmailStepTwo(inputPayload))
    // setMessageToggle(!messageToggle)
    verifyEmail({
      affiliateCode,
      email: email,
      verification_code: Number(otp),
      productId: 4127,
    })
  }

  return (
    <Modal
      open={show}
      onClose={() => setShow(false)}
      sx={{
        marginTop: '12rem',
      }}
    >
      <Box sx={registerStepStyle.blueBox}>
        <Typography
          variant="h4"
          sx={{
            fontSize: { lg: '36px', md: '36px', sm: '36px', xs: '24px' },
          }}
        >
          Confirm your Identity
        </Typography>
        <Typography color="#36414E" fontSize={'16px'} align="center" padding="12px 0px 32px 0px">
          We sent a code to {email}. Enter it here to confirm your identity.
        </Typography>
        <MuiOtpInput
          inputMode="numeric"
          value={otp}
          length={6}
          onChange={handleOtpChange}
          TextFieldsProps={{ variant: 'standard', error: isVerifyError }}
        ></MuiOtpInput>
        {isVerifyError && (
          <Box display="flex" mt={1} gap={1} alignItems={'flex-start'}>
            <ErrorIcon sx={{ color: '#CA303A' }} fontSize="12px" />

            <Typography textAlign={'start'} fontSize={'12px'} color="#CA303A">
              Verification code is incorrect, please try again and/or check if you entered the code correctly
            </Typography>
          </Box>
        )}
        <Typography color="#36414E" fontSize={'16px'} align="center" padding="32px 0px">
          Didn't receive the code?
          <Button onClick={resend} disabled={resendDisabled} sx={{ textTransform: 'none' }}>
            {resendDisabled ? `Resend in ${countdown}s` : 'Resend'}
          </Button>
        </Typography>
        {productId === '511801' ? (
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
              onClick={() => setShow(false)}
              startIcon={<ArrowBackIcon />}
              variant="text"
              sx={{ textTransform: 'none' }}
            >
              Back
            </Button>
            <Button sx={registerStepStyle.continueBtn} onClick={matchVerificationCode} disabled={otp.length < 6}>
              Continue
            </Button>
          </Box>
        ) : (
          <Button sx={registerStepStyle.nextButton} onClick={matchVerificationCode} disabled={otp.length < 6}>
            Verify
          </Button>
        )}
      </Box>
    </Modal>
  )
}

const registerStepStyle = {

    blueBox: {
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        pt: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
        pr: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
        pb: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
        pl: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
        width: { lg: '502px', md: '502px', sm: '502px', xs: '343px' },
        height: { lg: '438px', md: '438px', sm: '438px', xs: '386px' },
        background: '#F5F7FF',
        borderRadius: '8px',
        top: '40%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
      nextButton: {
        textTransform: 'none',
        width: { lg: '50%', md: '50%', sm: '50%', xs: '60%' },
        height: '40px',
        backgroundColor: '#3C4FB9',
        color: 'white',
        borderRadius: '100px',
        mt: '10px',
        '&:hover': {
          backgroundColor: '#9BA5DF',
          color: '#36414E',
        },
        '&:disabled': {
          backgroundColor: '#C4CAF1',
          color: 'white',
          textTransform: 'none',
        },
      },
      continueBtn: {
        textTransform: 'none',
        width: { lg: '20%', md: '20%', sm: '20%', xs: '20%' },
        height: '40px',
        backgroundColor: '#3C4FB9',
        color: 'white',
        borderRadius: '100px',
        '&:hover': {
          backgroundColor: '#9BA5DF',
          color: '#36414E',
        },
        '&:disabled': {
          backgroundColor: '#C4CAF1',
          color: 'white',
          textTransform: 'none',
        },
      
      },
}

export default EmailVerifyModal;